// extracted by mini-css-extract-plugin
export var actionButton = "_fp-t";
export var buttonContainer = "_fp-0";
export var buttonContainer2 = "_fp-1";
export var buttonSection = "_fp-2";
export var details = "_fp-3";
export var dropdownItem = "_fp-5";
export var dropdownItemsContainer = "_fp-4";
export var fileInput = "_fp-r";
export var headerButton = "_fp-6";
export var icon = "_fp-7";
export var input = "_fp-8";
export var macroListItem = "_fp-9";
export var mainContent = "_fp-a";
export var microText = "_fp-b";
export var modal = "_fp-w";
export var optionsButton = "_fp-c";
export var paperclip = "_fp-s";
export var pillContent = "_fp-d";
export var preview = "_fp-e";
export var preview2 = "_fp-f";
export var quillEditor = "_fp-q";
export var selectedMacro = "_fp-g";
export var sidebar = "_fp-h";
export var sidebarHeader = "_fp-j";
export var sidebarList = "_fp-i";
export var sidebarListItem = "_fp-k";
export var sidebarSearch = "_fp-l";
export var snoozeDurationWrapper = "_fp-v";
export var statusPillContainer = "_fp-m";
export var tagsContainer = "_fp-n";
export var unselectedMacro = "_fp-o";
export var variable = "_fp-u";
export var wrapper = "_fp-p";